export const PAYMENT_DETAILS='PAYMENT_DETAILS';